import React from 'react';
import axios from "../../../containers/api";
import Config from "../../../constants/config";
import { convertDate, getkalas, showCatchError, toCurrency, toEnglishNumbers } from "../../../helpers/Utils";
import {Row, Card, CardBody, Button, Collapse, FormGroup, Label, Badge, CardTitle,} from "reactstrap";
import {Colxx, Separator} from "../../../components/common/CustomBootstrap";
import {Table} from "../../../components/table/Table";
import DatePicker, {utils} from "react-modern-calendar-datepicker";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";

class LoadHallCargo extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            CargosSearchResult: [],
            kalas: [],
            kala: null,
            TransportationCompanyList: [],
            TransportationCompany: null,
            CargoStatus: [
                { value: 0, text: 'فعال' },
                { value: 1, text: 'غیرفعال' },
                { value: 2, text: 'همه' }
            ],
            selectedCargoStatus: { value: 2, text: 'همه' },
           
            date: utils('fa').getToday(),
            toDate: utils('fa').getToday(),
            collapse: true
        }
    }

    componentDidMount() {
        this.GetTransportationCompanyList();
       
        //console.log('loadbase')
        try {
            this.getkalasApi().then(r => console.log(r));
        } catch (err) {
            console.log(err);
        }
    }

    GetTransportationCompanyList = () => {
        axios.get('/api/v1/transportation-company-halls/GetByLoadHallId?Id=' + 0)
            .then((res) => {
                this.setState({TransportationCompanyList: res.data.data});
            })
            .catch((error) => {
                this.props.hideSpinner();
                console.log(error.response);
                this.props.showAlert(showCatchError(error), "error");
            });
    };
    
    async getkalasApi() {
        try {
            await getkalas()
                .then((res) => this.setState({kalas: res.data}) );
        } catch (err) {
            this.props.showAlert(showCatchError(err), "error");
        }
    }
    SearchCargo = () => {
        let searchModel = {
            FromDate: convertDate(this.state.date),
            ToDate: convertDate(this.state.toDate),
            ReceiverCustomerId: [],
            SenderCustomerId: [],
            
            CargoStatus: toEnglishNumbers(this.state.selectedCargoStatus.value),
            KalaId: [],
            //kalaId: this.state.kala != null ? this.state.kala.id : null, 
            TransportationCompanyId: this.state.TransportationCompany != null ? this.state.TransportationCompany.transportationCompanyId : null,
            
        };



        if (this.state.kala !== null) {
             
            searchModel.KalaId.push(this.state.kala.id)
             
        }

        this.props.showSpinner();
        axios.post('/api/v1/cargos/SearchCargo', searchModel)
            .then((res) => {
                this.props.hideSpinner();
                console.log(res.data.data)
                this.setState({ CargosSearchResult: res.data.data, searchFilters: false });
                if (this.state.CargosSearchResult.length === 0) {
                    this.props.showAlert("موردی یافت نشد", "warning");
                } else {
                    this.props.showAlert(this.state.CargosSearchResult.length.toString() + " مورد یافت شد", "success");
                }

            })
            .catch((error) => {
                this.props.hideSpinner();
                console.log(error.response);
                this.props.showAlert(showCatchError(error), "error");
            })
    };
 

    Reset = () => {
        this.setState({
            kala: null,
            TransportationCompany: null,
            selectedCargoStatus: { value: 2, text: 'همه' },
            date: utils('fa').getToday(),
            toDate: utils('fa').getToday(),
            CargosSearchResult: []
        });
    };

    selectHandleChange = (event, value, name) => {
        this.setState({[name]: value });
    };

    render() {
        return (
            <>
                <Row>
                    <Colxx xxs="12">
                        <h3>ليست اعلام بار </h3>
                        <Separator className="mb-5" />
                    </Colxx>
                </Row>

                <Row>
                    <Colxx xxs="12">
                        <Card>
                            <CardBody >
                            <CardTitle>جستجو</CardTitle> 
                                    <div className="p-4 pt-5 border d-flex flex-column">
                                        <div className="d-flex w-100 flex-wrap justify-content-center">
                                            <FormGroup className="w-md-30 w-100 px-1">
                                                <Label>از تاریخ</Label>
                                                <DatePicker
                                                    value={this.state.date}
                                                    onChange={(newDate) => this.setState({date: newDate})}
                                                    inputPlaceholder="لطفا یک تاریخ انتخاب کنید"
                                                    shouldHighlightWeekends
                                                    inputClassName="form-control"
                                                    locale="fa"
                                                    calendarClassName="calendar"
                                                    colorPrimary={Config.color}
                                                    calendarPopperPosition={'bottom'}
                                                />
                                            </FormGroup>

                                            <FormGroup className="w-md-30 w-100 px-1">
                                                <Label>تا تاریخ</Label>
                                                <DatePicker
                                                    value={this.state.toDate}
                                                    onChange={(newDate) => this.setState({toDate: newDate})}
                                                    inputPlaceholder="لطفا یک تاریخ انتخاب کنید"
                                                    shouldHighlightWeekends
                                                    inputClassName="form-control"
                                                    locale="fa"
                                                    calendarClassName="calendar"
                                                    colorPrimary={Config.color}
                                                    calendarPopperPosition={'bottom'}
                                                />
                                            </FormGroup>
                                            <FormGroup className="w-md-25 w-100 px-1">
                                                <Label>وضعیت</Label>
                                                <Autocomplete
                                                    disableClearable
                                                    clearText={"حذف"}
                                                    closeText={"بستن"}
                                                    noOptionsText={"در حال دریافت اطلاعات.."}
                                                    openText={"باز کردن"}
                                                    className="react-select__control"
                                                    id="selectedCargoStatus"
                                                    options={this.state.CargoStatus}
                                                    getOptionLabel={(option) => option.text}
                                                    value={this.state.selectedCargoStatus}
                                                    onChange={(e, v) => this.selectHandleChange(e, v, "selectedCargoStatus")}
                                                    renderInput={(params) => (<TextField{...params} variant="standard" />)}
                                                />
                                            </FormGroup>
                                        </div>
                                            <div className="d-flex w-100 flex-wrap justify-content-center">

                                            <FormGroup className="w-md-30 w-100 px-1">
                                                <Label>شرکت حمل و نقل</Label>
                                                <Autocomplete
                                                    clearText={"حذف"}
                                                    closeText={"بستن"}
                                                    noOptionsText={"در حال دریافت اطلاعات.."}
                                                    openText={"باز کردن"}
                                                    className="react-select__control"
                                                    id="TransportationCompany"
                                                    options={this.state.TransportationCompanyList}
                                                    getOptionLabel={(option) => option.transportationCompanyName}
                                                    value={this.state.TransportationCompany}
                                                    onChange={(e, v) => this.selectHandleChange(e, v, "TransportationCompany")}
                                                    renderInput={(params) => (<TextField{...params} variant="standard"/>)}
                                                />
                                            </FormGroup>

                                            <FormGroup className="w-md-30 w-100 px-1">
                                                <Label>نوع محموله</Label>
                                                <Autocomplete
                                                    clearText={"حذف"}
                                                    closeText={"بستن"}
                                                    noOptionsText={"در حال دریافت اطلاعات.."}
                                                    openText={"باز کردن"}
                                                    className="react-select__control"
                                                    id="kala"
                                                    options={this.state.kalas}
                                                    getOptionLabel={(option) => option.kalaDesc}
                                                    value={this.state.kala}
                                                    onChange={(e, v) => this.selectHandleChange(e, v, "kala")}
                                                    renderInput={(params) => (<TextField{...params} variant="standard"/>)}
                                                />
                                            </FormGroup>
                                            
                                            
                                        </div>

                                        <div className="d-flex mt-2 justify-content-center">
                                            <FormGroup className="text-center">
                                                <Button color="primary" className="btn-lg mx-2" onClick={() => this.SearchCargo()}>
                                                    جستجو
                                                </Button>
                                            </FormGroup>

                                            <FormGroup className="text-center">
                                                <Button color="primary" className="btn-lg mx-2" onClick={() => this.Reset()}>
                                                    پاک کردن
                                                </Button>
                                            </FormGroup>
                                        </div>
                                    </div>
                                <Table
                                    tableHeaders={[
                                        "شناسه",
                                        "تاریخ",
                                        "محموله",
                                        "مبدا",
                                        "مقصد",
                                        "تعداد",
                                        "وزن بار",
                                        "نوع ماشین",
                                        "توضیحات", 
                                        "کرایه",
                                        
                                        "شرکت حمل و نقل",
                                        "وضعیت بار",
                                    ]}

                                    tableRow={this.state.CargosSearchResult}

                                    tableData={[
                                        Cargo => {
                                            return Cargo.id;
                                        },
                                        
                                        Cargo => {
                                            return Cargo.cargoDate;
                                        },
                                        Cargo => {
                                            return Cargo.kalaDesc;
                                        },
                                        Cargo => {
                                            return Cargo.cargoSource;
                                        },
                                        Cargo => {
                                            return Cargo.cargoDestination;
                                        },
                                        Cargo => {
                                            return Cargo.freighterNumber;
                                        },
                                        Cargo => {
                                            return Cargo.kalaWeight;
                                        },
                                        Cargo => {
                                            return Cargo.loaderTypeNames;
                                        },
                                        Cargo => {
                                            return Cargo.description;
                                        },
                                        Cargo => {
                                            return toCurrency(Cargo.cargoRent);
                                        },
                                        Cargo => {
                                            return Cargo.transportationCompanyName;
                                        },
                                        Cargo => {
                                            return (
                                                Cargo.cargoStatus === 0 ?
                                                    <Badge color="outline-warning" pill>در حال ارسال</Badge>
                                                    :
                                                    <Badge color="outline-success" pill>اتمام بار</Badge>
                                            );
                                        },
                                        
                                        
                                    ]}
                                />
                            </CardBody>
                        </Card>
                    </Colxx>
                </Row>
            </>
        );
    }
}

export default LoadHallCargo;